import { frontendURL } from '../../../../helper/URLHelper';
import {
  ROLES,
  SCHEDULED_MESSAGE_VIEW_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
const ScheduledMessages = () => import('../../../../modules/scheduled-messages/pages/Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/automations/scheduled-messages'),
      name: 'scheduled_messages_settings',
      meta: {
        permissions: [...ROLES, SCHEDULED_MESSAGE_VIEW_PERMISSIONS],
      },
      component: ScheduledMessages,
    },
  ],
};
